// css =>
import "../../BaseStructure.css";
import Styled from "./header.module.css";

function Header() {
    return(
        <div className={`row ${ Styled.HeaderBox }`}>
            <div className="col-12">
                <h1>We Dook</h1>
            </div>
        </div>
    );
}

export default Header;
